import React from "react";
import { connect } from 'react-redux';
export const Icons = {
  Menu,
  Mail,
  Loading,
  RightArrow,
  Deposit,
  WithDraw,
  Transfer,
  CN,
  HK,
  Close,
  ArrowDown,
  ArrowUp,
  ArrowLeft,
  ArrowDoubleLeft,
  changePasswordSuccess,
  ArrowDoubleRight,
  cashSuccess,
  tips_success,
  MultipleSelection,
  MultipleSelectionLight,
  Check,
  Uncheck,
  SelectHit,
  SelectNormal,
  Plus,
  WatchlistDelete,
  Edit,
};

function Menu(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
      <title>{props.title}</title>
    </svg>
  );
}

function Mail(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
      <title>{props.title}</title>
    </svg>
  );
}

function Loading(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 100 100"
      stroke="currentColor"
    >
      <path
        fill="#fff"
        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
      <title>{props.title}</title>
    </svg>
  );
}

function RightArrow(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5l7 7-7 7"
      />
      <title>{props.title}</title>
    </svg>
  );
}

function Deposit(props) {
  return (
    <svg
      t="1609382626520"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3011"
      width="16"
      height="16"
    >
      <path
        d="M512 30.72a481.28 481.28 0 1 0 481.28 481.28A481.28 481.28 0 0 0 512 30.72z m-10.24 757.76L307.2 583.68h102.4V286.72h184.32v296.96h112.64z"
        fill="#2274AE"
        p-id="3012"
      ></path>
      <path
        d="M593.92 286.72H409.6v296.96H307.2l194.56 204.8 204.8-204.8H593.92V286.72z"
        fill="#2274AE"
        p-id="3013"
      ></path>
      <path
        d="M737.28 655.36H634.88l-51.2 51.2h148.48a35.84 35.84 0 0 1 0 71.68H512l-10.24 10.24-10.24-10.24H261.12a35.84 35.84 0 0 1 0-71.68h162.816l-48.64-51.2H276.48a102.4 102.4 0 0 0-102.4 102.4v96.8704a480.5632 480.5632 0 0 0 446.976 126.0544A112.64 112.64 0 0 1 716.8 808.96h122.88v-51.2a102.4 102.4 0 0 0-102.4-102.4z"
        fill="#FFFFFF"
        p-id="3014"
      ></path>
      <path
        d="M583.68 706.56l51.2-51.2H375.296l48.64 51.2H583.68zM501.76 788.48l10.24-10.24h-19.968l9.728 10.24zM686.08 921.6a30.72 30.72 0 0 1 61.44 0 30.0032 30.0032 0 0 1-2.2528 11.3664 484.4544 484.4544 0 0 0 116.224-90.2144A80.6912 80.6912 0 0 0 839.68 839.68H716.8a81.92 81.92 0 0 0-64.2048 133.12 492.4416 492.4416 0 0 0 56.2176-21.1968A30.72 30.72 0 0 1 686.08 921.6z"
        fill="#FFFFFF"
        p-id="3015"
      ></path>
      <path
        d="M355.4304 655.36l48.64 51.2h19.8656l-48.64-51.2h-19.8656zM634.88 655.36l-51.2 51.2h20.0704l51.2-51.2H634.88z"
        p-id="3016"
      ></path>
      <path
        d="M365.568 645.12l68.096 71.68H573.44l71.68-71.68H365.568z"
        p-id="3017"
      ></path>
      <path
        d="M593.92 583.68V286.72H409.6v296.96H307.2l194.56 204.8 204.8-204.8H593.92z"
        fill="#FFFFFF"
        p-id="3018"
      ></path>
      <path
        d="M482.304 768l9.728 10.24H512l10.24-10.24h-39.936z"
        p-id="3019"
      ></path>
      <title>{props.title}</title>
    </svg>
  );
}

function WithDraw(props) {
  return (
    <svg
      t="1609382914144"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3293"
      width="16"
      height="16"
    >
      <path
        d="M512 512m-481.28 0a481.28 481.28 0 1 0 962.56 0 481.28 481.28 0 1 0-962.56 0Z"
        fill="#2274AE"
        p-id="3294"
      ></path>
      <path
        d="M716.8 808.96h122.88v-51.2a102.4 102.4 0 0 0-102.4-102.4H276.48a102.4 102.4 0 0 0-102.4 102.4v96.8704a480.5632 480.5632 0 0 0 446.976 126.0544A112.64 112.64 0 0 1 716.8 808.96z m-455.68-30.72a35.84 35.84 0 0 1 0-71.68h471.04a35.84 35.84 0 0 1 0 71.68z"
        fill="#FFFFFF"
        p-id="3295"
      ></path>
      <path
        d="M686.08 921.6a30.72 30.72 0 0 1 61.44 0 30.0032 30.0032 0 0 1-2.2528 11.3664 484.4544 484.4544 0 0 0 116.224-90.2144A80.6912 80.6912 0 0 0 839.68 839.68H716.8a81.92 81.92 0 0 0-64.2048 133.12 492.4416 492.4416 0 0 0 56.2176-21.1968A30.72 30.72 0 0 1 686.08 921.6z"
        fill="#FFFFFF"
        p-id="3296"
      ></path>
      <path d="M393.728 655.36h214.4256v51.2H393.728z" p-id="3297"></path>
      <path
        d="M307.2 491.52h102.4v296.96h184.32V491.52h112.64L501.76 286.72 307.2 491.52z"
        fill="#FFFFFF"
        p-id="3298"
      ></path>
      <path d="M409.6 768h184.32v10.24H409.6z" p-id="3299"></path>
      <title>{props.title}</title>
    </svg>
  );
}

function Transfer(props) {
  return (
    <svg
      t="1609382983544"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3423"
      width="16"
      height="16"
    >
      <path
        d="M512 512m-481.28 0a481.28 481.28 0 1 0 962.56 0 481.28 481.28 0 1 0-962.56 0Z"
        fill="#2274AE"
        p-id="3424"
      ></path>
      <path
        d="M658.432 715.3664a81.92 81.92 0 0 1 0-163.84H747.52v-36.864A74.4448 74.4448 0 0 0 673.3824 440.32H338.7392a74.3424 74.3424 0 0 0-74.3424 74.3424v163.84c0 89.8048 33.28 125.5424 74.3424 125.5424h334.6432C700.8256 803.7376 737.28 768 737.28 715.3664zM327.68 529.5104a26.0096 26.0096 0 1 1 0-52.0192h342.016a26.0096 26.0096 0 1 1 0 52.0192z"
        fill="#FFFFFF"
        p-id="3425"
      ></path>
      <path
        d="M747.52 574.1568h-89.088a59.4944 59.4944 0 1 0 0 118.8864H747.52a59.4944 59.4944 0 0 0 0-118.8864z m-89.2928 81.92a22.3232 22.3232 0 1 1 22.3232-22.2208 22.3232 22.3232 0 0 1-22.1184 22.016z"
        fill="#FFFFFF"
        p-id="3426"
      ></path>
      <path
        d="M366.7968 471.04a740.9664 740.9664 0 0 0 66.8672-51.2h-89.9072a169.472 169.472 0 0 0 23.04 51.2z"
        p-id="3427"
      ></path>
      <path
        d="M489.6768 358.4l-61.44-10.24s61.44-102.4 122.88-40.96c40.96-30.72 71.68-51.2 71.68-51.2s-51.2-71.68-163.84-40.96a159.0272 159.0272 0 0 0-92.16 245.76 957.5424 957.5424 0 0 0 122.88-102.4z"
        fill="#FFFFFF"
        p-id="3428"
      ></path>
      <path
        d="M547.9424 430.08a69.8368 69.8368 0 0 1-44.9536 22.2208 48.8448 48.8448 0 0 1-34.6112-16.5888l-6.2464-6.3488-7.0656 5.3248c-40.2432 30.208-70.9632 50.688-71.68 51.2l-8.8064 5.8368H643.072a165.1712 165.1712 0 0 0 30.72-51.2c1.2288-3.4816 2.4576-6.9632 3.4816-10.24z"
        p-id="3429"
      ></path>
      <path
        d="M522.24 391.68l61.44 10.24s-61.44 102.4-122.88 40.96c-40.96 30.72-71.68 51.2-71.68 51.2s51.2 71.68 163.84 40.96a159.0272 159.0272 0 0 0 92.16-245.76 957.5424 957.5424 0 0 0-122.88 102.4z"
        fill="#FFFFFF"
        p-id="3430"
      ></path>
      <path d="M397.5168 522.24h204.8v7.168h-204.8z" p-id="3431"></path>
      <title>{props.title}</title>
    </svg>
  );
}

function HK(props) {
  return (
    <svg
      t="1609384905782"
      className="icon"
      viewBox="0 0 1105 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3150"
      width="200"
      height="200"
    >
      <path
        d="M243.34360946 233.16294624h650.43126129a141.39810029 141.39810029 0 0 1 141.39810029 139.41852689v286.75534736a141.39810029 141.39810029 0 0 1-141.39810029 139.41852687h-650.43126129a141.39810029 141.39810029 0 0 1-141.39810028-139.41852687V372.58147313a141.39810029 141.39810029 0 0 1 141.39810028-139.41852689z"
        fill="#DE2910"
        p-id="3151"
      ></path>
      <path
        d="M559.2269655 509.7376304l5.09033161 5.09033161-5.09033161 5.37312781-5.37312783-5.37312781z m0 0"
        fill="#FF0000"
        p-id="3152"
      ></path>
      <path
        d="M559.2269655 514.82796201a99.82705881 99.82705881 0 0 1-51.18611232-128.38947507 90.77758037 90.77758037 0 0 1 101.52383601-49.77213128c-19.23014164 9.61507082-32.23876687 22.90649225-19.51293783 42.13663388a44.96459588 44.96459588 0 0 1-19.51293785 64.76032993 43.55061489 43.55061489 0 0 0-11.31184801 71.26464254z m0 0"
        fill="#FFFFFF"
        p-id="3153"
      ></path>
      <path
        d="M558.3785769 515.6763506a63.91194132 63.91194132 0 0 1-30.54198967-50.0549275v-10.7462556a68.43668053 68.43668053 0 0 1 12.44303283-42.1366339h1.6967772v1.69677721a41.00544908 41.00544908 0 0 0-6.22151641 10.46345942 72.11303115 72.11303115 0 0 0-6.22151642 30.54198965v10.18066322a60.23559071 60.23559071 0 0 0 28.27962006 48.3581503v1.6967772h-1.41398101z m-14.42260622-131.21743705l8.20108979 7.6354974 9.61507084-5.93872019-4.52473922 10.18066321 8.20108982 7.35270121h-11.02905183l-4.52473921 10.18066322-2.2623696-10.74625561h-11.02905182l9.61507081-5.65592402z m0 0"
        fill="#FF0000"
        p-id="3154"
      ></path>
      <path
        d="M559.2269655 514.82796201a100.10985501 100.10985501 0 0 1 106.0485752-87.66682218 90.77758037 90.77758037 0 0 1 78.61734376 81.44530576c-14.98819862-15.55379103-31.95597068-23.75488085-46.09578069-5.93872021a44.11620729 44.11620729 0 0 1-67.30549573 1.413981 43.83341109 43.83341109 0 0 0-71.26464254 11.31184803z m0 0"
        fill="#FFFFFF"
        p-id="3155"
      ></path>
      <path
        d="M558.09578069 514.2623696A62.49796033 62.49796033 0 0 1 596.83886017 469.86336611l9.89786702-3.6763506a64.47753373 64.47753373 0 0 1 43.83341108 0v1.41398101a49.77213131 49.77213131 0 0 0-11.87744042-2.54516581 72.96141974 72.96141974 0 0 0-30.54198966 3.1107582l-9.61507082 3.67635062a61.08397932 61.08397932 0 0 0-37.04630228 43.26781868h-1.413981z m119.90558905-54.0140743l-4.24194301 10.18066322 8.2010898 7.63549741h-10.74625561l-4.80753542 9.89786702-2.26236961-11.02905181h-11.02905182l9.61507083-5.65592401-2.2623696-11.02905183 8.20108981 7.63549741z m0 0"
        fill="#FF0000"
        p-id="3156"
      ></path>
      <path
        d="M559.2269655 514.82796201a99.82705881 99.82705881 0 0 1 116.22923843 74.37540075 91.62596898 91.62596898 0 0 1-53.44848191 100.10985499c10.18066322-19.23014164 12.72582902-37.61189467-8.20108982-45.81298449a44.39900348 44.39900348 0 0 1-22.05810363-63.91194132 44.11620729 44.11620729 0 0 0-32.52156307-64.76032993z m0 0"
        fill="#FFFFFF"
        p-id="3157"
      ></path>
      <path
        d="M559.2269655 513.69677721a63.06355271 63.06355271 0 0 1 53.73127811 22.90649224l6.78710881 7.91829361a69.56786534 69.56786534 0 0 1 14.13981002 41.8538377 54.29687052 54.29687052 0 0 0 0-12.16023664 74.65819695 74.65819695 0 0 0-12.44303283-28.27962005l-6.50431262-7.91829362a60.51838691 60.51838691 0 0 0-52.03450088-22.34089985z m87.94961837 98.1302816h-11.02905183l-4.5247392 10.18066321-2.26236961-11.02905182h-11.02905183l9.61507084-5.65592401-2.82796203-13.00862522 8.48388603 7.3527012 9.61507083-5.655924-4.80753543 9.89786701z m0 0"
        fill="#FF0000"
        p-id="3158"
      ></path>
      <path
        d="M559.2269655 514.82796201a100.3926512 100.3926512 0 0 1-35.06672888 134.04539906 90.77758037 90.77758037 0 0 1-111.42170302-20.36132645c21.20971504 3.6763506 39.59146809 0 40.72265289-22.05810363a44.68179969 44.68179969 0 0 1 54.0140743-40.72265288 44.11620729 44.11620729 0 0 0 51.75170471-50.9033161z m0 0"
        fill="#FFFFFF"
        p-id="3159"
      ></path>
      <path
        d="M560.35815029 514.5451658a62.78075652 62.78075652 0 0 1-5.3731278 58.53881352l-5.65592403 9.04947843a68.43668053 68.43668053 0 0 1-35.63232125 26.30004664v-1.413981a43.26781869 43.26781869 0 0 0 11.31184802-5.09033161 72.11303115 72.11303115 0 0 0 22.90649224-20.36132644l5.37312781-8.76668223a61.64957172 61.64957172 0 0 0 5.09033162-56.5592401v-1.413981z m-66.17431092 113.11848023l-2.26236961-11.02905182h-11.02905183l9.61507084-5.37312781-2.26236962-11.02905183 8.20108982 7.63549742 9.61507082-5.65592402-4.52473921 10.18066323 7.91829362 7.63549741h-11.02905182z m0 0"
        fill="#FF0000"
        p-id="3160"
      ></path>
      <path
        d="M559.2269655 514.82796201a99.2614664 99.2614664 0 0 1-137.72174968 7.63549741 91.06037658 91.06037658 0 0 1-14.98819861-113.11848023c2.82796201 21.20971504 11.59464423 37.61189467 33.36995164 31.95597068a44.96459588 44.96459588 0 0 1 55.14525912 39.02587567 44.11620729 44.11620729 0 0 0 64.19473753 33.65274786z m0 0"
        fill="#FFFFFF"
        p-id="3161"
      ></path>
      <path
        d="M559.79255789 515.6763506a63.06355271 63.06355271 0 0 1-56.55924011 13.00862524l-10.18066321-2.54516581a70.41625394 70.41625394 0 0 1-37.61189469-25.73445426v-1.6967772h1.97957341a46.3785769 46.3785769 0 0 0 7.91829361 9.33227461 75.50658555 75.50658555 0 0 0 26.58284286 15.55379105l9.89786702 2.5451658a61.64957172 61.64957172 0 0 0 56.55924012-12.72582902h1.69677719z m-128.67227124-28.27962005l9.33227461-5.37312781-2.26236961-11.02905182 8.48388602 7.63549741 9.33227462-5.65592401-4.5247392 10.18066322 8.48388601 7.63549742-11.02905181-1.413981-4.52473923 10.18066322-2.54516581-11.02905183z m0 0"
        fill="#FF0000"
        p-id="3162"
      ></path>
      <title>{props.title}</title>
    </svg>
  );
}

function CN(props) {
  return (
    <svg
      t="1609384931675"
      className="icon"
      viewBox="0 0 1105 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3286"
      width="200"
      height="200"
    >
      <path
        d="M243.34360946 229.20379943h650.43126129a141.39810029 141.39810029 0 0 1 141.39810029 141.39810028v282.79620058a141.39810029 141.39810029 0 0 1-141.39810029 141.39810028h-650.43126129a141.39810029 141.39810029 0 0 1-141.39810028-141.39810028V370.60189971a141.39810029 141.39810029 0 0 1 141.39810028-141.39810028z"
        fill="#DE2910"
        p-id="3287"
      ></path>
      <path
        d="M276.99635733 318.85019502l17.81616063 56.55924012h58.25601734l-46.94416931 34.21834025 17.81616063 55.14525911-46.94416929-34.21834026L229.20379943 463.64184971l18.09895685-55.14525911L200.92417938 374.27825033h58.53881352z m151.57876351-28.27962005v18.94734542l17.81616063 7.06990503-18.66454924 4.8075354v19.23014163l-10.18066322-16.40217962-18.66454922 4.80753541 12.1602366-14.70540242-12.1602366-16.68497585 17.81616063 7.06990502z m65.32592233 61.93236792l-8.76668223 16.96777202 13.57421763 13.57421764-18.66454925-3.1107582-9.0494784 17.25056822-2.82796201-18.94734544-18.94734543-3.1107582 17.25056823-8.48388602-3.11075821-18.94734544 13.57421764 13.57421763z m-19.51293784 77.48615894l5.65592399 18.38175305h19.23014166l-15.27099484 11.31184801 5.65592402 18.09895685-15.55379103-11.31184803-15.27099484 11.31184803 5.93872021-18.09895685-15.55379102-11.31184801h19.23014163z m-45.81298449 58.53881352l-1.41398101 19.23014164 17.81616064 6.78710881-18.38175305 4.80753542-1.41398099 19.23014163-10.18066323-16.11938343-18.66454923 4.5247392 12.44303281-14.70540242-9.89786699-16.68497583 17.81616063 7.06990501z m0 0"
        fill="#FFDE00"
        p-id="3288"
      ></path>
      <title>{props.title}</title>
    </svg>
  );
}

function Close(props) {
  return (
    <svg
      t="1610005016088"
      className="icon"
      viewBox="0 0 1105 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1417"
      width="16"
      height="16"
    >
      <path
        d="M625.4592 512L798.72 338.1248A51.2 51.2 0 0 0 726.8352 266.24L552.96 439.5008 379.0848 266.24A51.2 51.2 0 0 0 307.2 338.1248L480.4608 512 307.2 685.8752A51.2 51.2 0 0 0 379.0848 757.76L552.96 584.4992 726.8352 757.76A51.2 51.2 0 0 0 798.72 685.8752z"
        fill="#FFFFFF"
        p-id="1418"
      ></path>
      <title>{props.title}</title>
    </svg>
  );
}

function ArrowUp(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 15l7-7 7 7"
      />
      <title>{props.title}</title>
    </svg>
  );
}

function ArrowDown(props) {
  return (
    <svg
      className="app-icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
        <title>{props.title}</title>
    </svg>
  );
}

function ArrowLeft(props) {
  return (
    <svg
    className="app-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      <title>{props.title}</title>
    </svg>
  )
}

function ArrowDoubleLeft(props) {
  return (
    <svg
    className="app-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
      <title>{props.title}</title>
    </svg>
  )
}

function ArrowDoubleRight(props) {
  return (
    <svg
    className="app-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
      <title>{props.title}</title>
    </svg>
  )
}

function changePasswordSuccess(props) {
  return (
      <svg className="app-icon" 
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 54 50"
      fill="none">
        <circle fill="#1bb965" cx="27" cy="25" r="24" />
        <path fill="#fff" d="M23.5,36a3,3,0,0,1-2.12-.88l-6-6a3,3,0,1,1,4.24-4.24l3.8,3.8L34.3,17A3,3,0,1,1,38.7,21l-13,14a3,3,0,0,1-2.14,1Z"/>
        <title>{props.title}</title>
      </svg>
  )
}

function cashSuccess(props){
  return(
    <svg className="app-icon" 
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 50"
    fill="none">
      <circle fill="#1bb965" cx="27" cy="25" r="24" />
      <path fill="#fff" d="M23.5,36a3,3,0,0,1-2.12-.88l-6-6a3,3,0,1,1,4.24-4.24l3.8,3.8L34.3,17A3,3,0,1,1,38.7,21l-13,14a3,3,0,0,1-2.14,1Z"/>
      <title>{props.title}</title>
    </svg>
  )
}

function tips_success(props){
    return(
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="app-icon" fill="none">
        <path fill="#1bb965" d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM35.7,20l-13,14a3,3,0,0,1-2.14,1H20.5a3,3,0,0,1-2.12-.88l-6-6a3,3,0,1,1,4.24-4.24l3.8,3.8L31.3,16A3,3,0,0,1,35.7,20Z"/>
        <title>{props.title}</title>
      </svg>
    )
}

function MultipleSelection(props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50'>
      <rect x='12' y='10' width='6' height='6' />
      <rect x='12' y='22' width='6' height='6' />
      <rect x='12' y='34' width='6' height='6' />
      <rect x='21' y='10' width='21' height='6' />
      <rect x='21' y='22' width='21' height='6' />
      <rect x='21' y='34' width='21' height='6' />
      <title>{props.title}</title>
    </svg>
  )
}

function MultipleSelectionLight() {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50'>
      <rect x='12' y='10' width='6' height='6' fill='#000' />
      <rect x='12' y='22' width='6' height='6' fill='#000'/>
      <rect x='12' y='34' width='6' height='6' fill='#000' />
      <rect x='21' y='10' width='21' height='6' fill='#000' />
      <rect x='21' y='22' width='21' height='6' fill='#000' />
      <rect x='21' y='34' width='21' height='6' fill='#000' />
    </svg>
  )
}

function Check(props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50' fill='var(--main-color)'>
      <path d='M15,13V37H39V13ZM36,34H18V16H36Z' />
      <polygon points='35.76 18.31 33.24 16.69 25.25 29.12 20.56 24.44 18.44 26.56 25.75 33.88 35.76 18.31' />
      <title>{props.title}</title>
    </svg>
  )
}

function Uncheck(props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50' fill='currentColor'>
      <path d='M36,16V34H18V16H36m3-3H15V37H39V13Z' />
      <title>{props.title}</title>
    </svg>
  )
}

function SelectHit(props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50'>
      <path fill='#2491e0' d='M27,16a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-4A13,13,0,1,0,40,25,13,13,0,0,0,27,12Z' />
      <circle fill='#2491e0' cx='27' cy='25' r='5' />
      <title>{props.title}</title>
    </svg>
  )
}

function SelectNormal(props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50' fill='currentColor' >
      <path d='M27,16a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-4A13,13,0,1,0,40,25,13,13,0,0,0,27,12Z' />
      <title>{props.title}</title>
    </svg>
  )
}

function Plus({ color }, props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
      <path stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 6v6m0 0v6m0-6h6m-6 0H6' />
      <title>{props.title}</title>
    </svg>
  )
}

function WatchlistDelete({color},props) {
  return (
    <svg className='app-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 54 50'>
      <rect fill={color ? color : '#999'} x='10.5' y='14' width='33' height='5' rx='2.5' />
      <path
        fill={color ? color :'#999'}
        d='M32.68,10a.82.82,0,0,1,.82.82V14h-13V10.82a.82.82,0,0,1,.82-.82H32.68m0-2H21.32a2.82,2.82,0,0,0-2.82,2.82V16h17V10.82A2.82,2.82,0,0,0,32.68,8Z'
        stroke={color}
      />
      <path fill={color ? color : '#999'} d='M14.5,22V35.79A6.21,6.21,0,0,0,20.71,42H33.29a6.21,6.21,0,0,0,6.21-6.21V22ZM22,38H20V26h2Zm6,0H26V26h2Zm6,0H32V26h2Z'  stroke={color} />
      <title>{props.title}</title>
    </svg>
  )
}


function Edit(props){
  return(
    <svg t="1644561559426" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17143" width="14" height="14">
      <path d="M940 596l-76-57.6c0.8-8 1.6-16.8 1.6-26.4s-0.8-18.4-1.6-26.4l76-57.6c20.8-16 26.4-44 12.8-68l-84.8-143.2c-9.6-16.8-28-27.2-47.2-27.2-6.4 0-12 0.8-18.4 3.2L712 228c-15.2-10.4-31.2-19.2-47.2-26.4l-13.6-92c-4-26.4-26.4-45.6-53.6-45.6H426.4c-27.2 0-49.6 19.2-53.6 44.8L360 201.6c-16 7.2-31.2 16-47.2 26.4l-90.4-35.2c-6.4-2.4-12.8-3.2-19.2-3.2-19.2 0-37.6 9.6-46.4 26.4L71.2 360c-13.6 22.4-8 52 12.8 68l76 57.6c-0.8 9.6-1.6 18.4-1.6 26.4s0 16.8 1.6 26.4l-76 57.6c-20.8 16-26.4 44-12.8 68l84.8 143.2c9.6 16.8 28 27.2 47.2 27.2 6.4 0 12-0.8 18.4-3.2L312 796c15.2 10.4 31.2 19.2 47.2 26.4l13.6 92c3.2 25.6 26.4 45.6 53.6 45.6h171.2c27.2 0 49.6-19.2 53.6-44.8l13.6-92.8c16-7.2 31.2-16 47.2-26.4l90.4 35.2c6.4 2.4 12.8 3.2 19.2 3.2 19.2 0 37.6-9.6 46.4-26.4l85.6-144.8c12.8-23.2 7.2-51.2-13.6-67.2zM704 512c0 105.6-86.4 192-192 192S320 617.6 320 512s86.4-192 192-192 192 86.4 192 192z" p-id="17144" fill="#707070"></path>
      <title>{props.title}</title>
      </svg>
  )
}

export default connect(
  state => ({
    language: state.app.language
  })
)(Menu,
  Mail,
  Loading,
  RightArrow,
  Deposit,
  WithDraw,
  Transfer,
  CN,
  HK,
  Close,
  ArrowDown,
  ArrowUp,
  ArrowLeft,
  ArrowDoubleLeft,
  changePasswordSuccess,
  ArrowDoubleRight,
  cashSuccess,
  tips_success,
  MultipleSelection,
  Check,
  Uncheck,
  SelectHit,
  SelectNormal,
  Plus,
  WatchlistDelete,
  Edit,)